export type ShowcaseShop = {
  /** In-app path (used when `href` is unset). */
  to: string
  /** Absolute storefront URL when the live shop has a custom domain. */
  href?: string
  nameKey: 'demoElectronics' | 'demoTickets' | 'cadenzaHarps' | 'loveMomento'
  kind: 'demo' | 'live'
}

export const SHOWCASE_SHOPS: ShowcaseShop[] = [
  { to: '/shop/demostore', nameKey: 'demoElectronics', kind: 'demo' },
  { to: '/shop/demotickets', nameKey: 'demoTickets', kind: 'demo' },
  {
    to: '/shop/cadenzaharps',
    href: 'https://storesch.com',
    nameKey: 'cadenzaHarps',
    kind: 'live',
  },
  { to: '/shop/lovemomento', nameKey: 'loveMomento', kind: 'live' },
]

export const DEMO_EXPLORE_LINK = {
  to: '/demo/explore-dashboard',
  nameKey: 'exploreDashboard' as const,
  hintKey: 'exploreDashboardHint' as const,
}
